import env from './env';
import { getFeatureFlagValue } from 'new/constants/featureFlags';
const CONFIG_API_SERVER_URL = env('REACT_APP_API_SERVER_URL') || env('API_SERVER_URL') || '';
const FEED_CONFIG = `${env('FEED_CONFIG')}`;

export const API_SERVER_URL = `${CONFIG_API_SERVER_URL}`;
export const CALL_PRIVATE_API = 'CallPrivateAPI';
export const CALL_AUTH_API = 'CallAuthAPI';
export const CALL_GENAI_API = 'CallGenAIAPI';

export const AUTH_LOGIN_URL = `${API_SERVER_URL}/token`;
export const AUTH_LOGIN_GTOKEN_URL = `${API_SERVER_URL}/gtoken`;

export const NOTIFICATIONS_URL = `${API_SERVER_URL}/notifications`;
export const DATA_CREDENTIALS_URL = `${API_SERVER_URL}/data_credentials`;
export const DATA_MAPS_URL = `${API_SERVER_URL}/data_maps`;
export const DATA_MAPS_NEW_URL = `${API_SERVER_URL}/data_maps_new`; // %%

export const DATA_SOURCES_URL = `${API_SERVER_URL}/data_sources`;
export const DATA_SETS_URL = `${API_SERVER_URL}/data_sets`;
export const DATA_SINKS_URL = `${API_SERVER_URL}/data_sinks`;

export const DATA_TRANSFORM_URL = `${API_SERVER_URL}/transform`;

export const GET_ENV_IDP_URL = `${API_SERVER_URL}/org_idp_mappings/client_config`;
export const GET_USERS_IDP_URL = `${API_SERVER_URL}/users/sso_options`;
export const GET_ENV_SSO_OPTIONS_URL = `${API_SERVER_URL}/sign_on_options`;

export const USERS_URL = `${API_SERVER_URL}/users`;

export const API_GENAI_SERVER_URL =
  env('REACT_APP_API_GENAI_SERVER_URL') || env('API_GENAI_SERVER_URL') || '';
export const API_GENAI_V1_SERVER_URL = `${API_GENAI_SERVER_URL}/v1`;

export const API_VEDA_AI_URL = env('REACT_APP_VEDA_AI_URL') || env('VEDA_AI_URL') || '';

export const API_EXPRESS_CODE_URL =
  env('REACT_APP_EXPRESS_CODE_URL') || env('EXPRESS_CODE_URL') || '';

export const API_SYSLOG_SERVER_URL = `${env('API_SYSLOG_SERVER_URL')}`;

export const WEBHOOK_SOURCE_URL = (orgWebhookURL = null, path = '/data') => {
  if (!orgWebhookURL) {
    let apiParts = API_SERVER_URL.split('/');

    return apiParts[2] === 'beta.nexla.com'
      ? `${apiParts[0]}//hooks-stage.nexla.com${path}`
      : `${apiParts[0]}//hooks-${apiParts[2]}${path}`;
  } else {
    return `${orgWebhookURL}${path}`;
  }
};

export const DATASET_OUTPUT_BASE_URL = () => {
  if (FEED_CONFIG && FEED_CONFIG !== '') {
    return FEED_CONFIG;
  }

  const UIUrl = window.location.hostname;

  let urlParts = UIUrl.split('.');
  urlParts[0] = urlParts[0] + '-sync';
  let newUrl = 'https://' + urlParts.join('.');

  return newUrl;
};

//TODO: Why do we need this?
export const ACCOUNT_METRICS_AGGREGATE_URL = `${API_SERVER_URL}/get_aggregate_metrics`;

// =============================================================================
// TEMPORARY: FastAPI Migration
// TODO: Remove this entire section once migration from Rails to FastAPI is complete
// =============================================================================

// TEMPORARY: FastAPI server URL - full URL from environment variable
const CONFIG_FASTAPI_SERVER_URL =
  env('REACT_APP_FASTAPI_SERVER_URL') || env('FASTAPI_SERVER_URL') || '';
export const FASTAPI_SERVER_URL = CONFIG_FASTAPI_SERVER_URL;

/**
 * TEMPORARY: Determines the base URL for an API request based on FastAPI configuration.
 * Uses GrowthBook feature flags to control FastAPI usage and route configuration.
 * TODO: Remove once FastAPI migration is complete
 * @param {string} endpoint - The API endpoint (e.g., '/flows', '/users/123')
 * @param {string} method - The HTTP method (e.g., 'GET', 'POST')
 * @returns {string} The base URL to use for the request
 */
export const getBaseUrl = (endpoint, method) => {
  // Check deployment-level gate first
  const deploymentEnabled =
    env('REACT_APP_FASTAPI_ENABLED') === 'true' || env('FASTAPI_ENABLED') === 'true';
  if (!deploymentEnabled) return API_SERVER_URL;

  // Then check GrowthBook feature flag for org-level control
  const fastApiEnabled = getFeatureFlagValue('UI_ENABLE_FAST_API');
  if (!fastApiEnabled) return API_SERVER_URL;

  // Get FastAPI routes from GrowthBook feature flag
  const fastApiRoutes = getFeatureFlagValue('UI_FASTAPI_ROUTES');
  if (
    !fastApiRoutes ||
    typeof fastApiRoutes !== 'object' ||
    Object.keys(fastApiRoutes).length === 0
  ) {
    return API_SERVER_URL;
  }

  const path = endpoint ? endpoint.split('?')[0] : '';
  const match = Object.entries(fastApiRoutes).find(
    ([route]) => path === route || path.startsWith(route + '/'),
  );

  if (match && match[1].includes(method)) {
    console.info(`[FastAPI] ${method} ${endpoint} → ${FASTAPI_SERVER_URL}`);
    return FASTAPI_SERVER_URL;
  }

  return API_SERVER_URL;
};

/**
 * TEMPORARY: Checks if an endpoint should use FastAPI based on feature flag and route matching.
 * Used by middleware to determine if fallback should be attempted.
 * TODO: Remove once FastAPI migration is complete
 * @param {string} endpoint - The API endpoint (e.g., '/flows', '/users/123')
 * @param {string} method - The HTTP method (e.g., 'GET', 'POST')
 * @returns {boolean} True if FastAPI should be used for this endpoint
 */
export const shouldUseFastAPI = (endpoint, method) => {
  // Check deployment-level gate first
  const deploymentEnabled =
    env('REACT_APP_FASTAPI_ENABLED') === 'true' || env('FASTAPI_ENABLED') === 'true';
  if (!deploymentEnabled) return false;

  // Then check GrowthBook feature flag
  const fastApiEnabled = getFeatureFlagValue('UI_ENABLE_FAST_API');
  if (!fastApiEnabled) return false;

  // Get FastAPI routes from GrowthBook feature flag
  const fastApiRoutes = getFeatureFlagValue('UI_FASTAPI_ROUTES');
  if (
    !fastApiRoutes ||
    typeof fastApiRoutes !== 'object' ||
    Object.keys(fastApiRoutes).length === 0
  ) {
    return false;
  }

  const path = endpoint ? endpoint.split('?')[0] : '';
  const match = Object.entries(fastApiRoutes).find(
    ([route]) => path === route || path.startsWith(route + '/'),
  );

  return match && match[1].includes(method);
};
// =============================================================================
